import type { IconNode } from '../types';

/**
 * @name cup-to-go
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNCA3aDE2IiAvPgogIDxwYXRoIGQ9Im0xOC4yIDExIC44LTQtLjgtNGMtLjEtLjUtLjYtMS0xLjItMUg3Yy0uNiAwLTEuMS40LTEuMiAxQzUuNSA0LjQgNSA3IDUgN2wuOCA0IiAvPgogIDxwYXRoIGQ9Ik0xOCAxOEg2bC0xLTdoMTRaIiAvPgogIDxwYXRoIGQ9Im03LjIgMTggLjYgM2MuMS41LjYgMSAxLjIgMWg2Yy42IDAgMS4xLS40IDEuMi0xbC42LTMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/cup-to-go
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const cupToGo: IconNode = [
  ['path', { d: 'M4 7h16', key: '6tx8e3' }],
  [
    'path',
    {
      d: 'm18.2 11 .8-4-.8-4c-.1-.5-.6-1-1.2-1H7c-.6 0-1.1.4-1.2 1C5.5 4.4 5 7 5 7l.8 4',
      key: '3uvubl',
    },
  ],
  ['path', { d: 'M18 18H6l-1-7h14Z', key: '1h22nb' }],
  ['path', { d: 'm7.2 18 .6 3c.1.5.6 1 1.2 1h6c.6 0 1.1-.4 1.2-1l.6-3', key: 'a9tm6z' }],
];

export default cupToGo;
